<template>
  <iMineTemplate
    :pageTitle="pageTitle"
    :activedParentKey="activedParentKey"
    :activedKey="activedKey"
  >
    <template #rightContent>
      <div class>
        <div class="msg-list bgfff pt30 pl20 pr20">
          <van-tabs
            animated
            v-model="tab_active"
            line-height="0"
            line-width="0"
            @change="handleTabs"
            :class="`tab${Number(tab_active + 1)}`"
            :border="false"
          >
            <van-tab>
              <template #title>{{ tabs[0].name }}</template>
              <div :class="{ bgfff: !list.length }" style="margin-top:22px">
                <van-row class="mt5" v-if="list && list.length">
                  <van-col
                    :span="12"
                    v-for="item in list"
                    :key="item.Id"
                    class="pt20 pl20 pr20 border i_radius mr20 mb20 msg_item"
                    @click.stop="lookMsg(item)"
                    @mousemove="item.hover = true"
                    @mouseleave="item.hover = false"
                  >
                    <van-cell
                      :value="item.CreateTime"
                      :border="false"
                      value-class="c777 f12"
                      class="pl0 pr0 pt0 pb20"
                    >
                      <template #title>
                        <div
                          class="custom-text c222 f16 fw600 text-left ellipsis-row1"
                          :class="!item.IsRead ? 'tagMark' : ''"
                        >
                          {{ item.MessageTitle }}
                        </div>
                      </template>
                    </van-cell>
                    <div class="c777 f14 text-left pb20 border-b ellipsis-row2">
                      {{ item.MessageContent }}
                    </div>
                    <van-cell
                      title="查看详情"
                      title-class="c777 f14 text-left"
                      class="pl0 pr0 pt15 pb15"
                      value-class="flex align-items-center justify-content-flex-end"
                    >
                      <div class="show-detail-right"></div>
                    </van-cell>
                  </van-col>
                </van-row>
                <EmptyControl
                  style="padding-top: 100px;"
                  v-if="!list.length && finished"
                  type="message"
                  text="没有收到消息哦~"
                />
              </div>
            </van-tab>
            <van-tab>
              <template #title>{{ tabs[1].name }}</template>
              <div :class="{ bgfff: !list.length }" style="margin-top:22px">
                <van-row class="mt5" v-if="list && list.length">
                  <van-col
                    :span="12"
                    v-for="item in list"
                    :key="item.Id"
                    class="pt20 pl20 pr20 border i_radius mr20 mb20"
                    @click.stop="lookMsg(item)"
                  >
                    <van-row
                      class="pr0 bgfff border-b pb20"
                      type="flex"
                      align="center"
                    >
                      <van-col :span="4" class="text-left" style="width:60px">
                        <van-image
                          width="60px"
                          height="60px"
                          lazy-load
                          :src="item.ImageUrl"
                          fit="scale-down"
                          style="background:#F6F6F6"
                        />
                      </van-col>
                      <van-col :span="20" class="text-left pl10">
                        <div
                          class="custom-text c222 f16 fw500"
                          :class="!item.IsRead ? 'tagMark' : ''"
                        >
                          {{ item.MessageTitle }}
                        </div>
                        <div
                          class="f14"
                          :class="!item.IsRead ? 'cFF3939' : 'c777'"
                          style="padding-top:12px"
                        >
                          {{ item.MessageContent }}
                        </div>
                      </van-col>
                    </van-row>
                    <van-cell
                      :title="item.CreateTime"
                      title-class="c777 f12 text-left"
                      class="pl0 pr0 pt15 pb15"
                      value-class="c777 f14 flex align-items-center justify-content-flex-end"
                    >
                      <template>
                        去处理
                        <van-icon
                          :name="require('@/assets/mine/right-arrow-icon.png')"
                          size="14px"
                          class="ml05"
                        />
                      </template>
                    </van-cell>
                  </van-col>
                </van-row>
                <EmptyControl
                  style="padding-top: 100px;"
                  v-if="!list.length && finished"
                  type="message"
                  text="没有收到消息哦~"
                />
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <iPagination
          :currentPage.sync="pageindex"
          :limit.sync="pageSize"
          :totalCount="totalCount"
          @turn="onLoad"
          v-if="list && list.length"
          small
        />
      </div>
    </template>
  </iMineTemplate>
</template>
<script>
import { BaseMixin } from "../../mixins/BaseMixin.js";
import { LinkTypeCode } from "@/dictionary/base.js";
export default {
  name: "Msg",
  mixins: [BaseMixin],
  data() {
    return {
      LinkTypeCode,
      pageTitle: ["我的账户", "消息通知"],
      activedParentKey: 1,
      activedKey: 16,
      tab_active: 0,
      tabs: [
        { key: 0, name: "活动消息" },
        { key: 1, name: "服务消息" },
      ],
      list: [],
      pageindex: 1,
      pageSize: 10,
      totalCount: 0,
      url: {
        list: "/api_customers/CustomerMessage/List", //客户消息表
      },
      finished: false,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    async onLoad() {
      await this.getMsg();
    },
    // 切换消息类型
    async handleTabs() {
      this.finished = false;
      this.list = [];
      this.pageindex = 1;
      await this.getMsg();
    },
    async getMsg() {
      this.$hys.openLoading();
      const res = await this.getAction(this.url.list, {
        messageType: this.tab_active == 0 ? 1 : 2,
        // isRead: "",
        // keyword: "",
        pageindex: this.pageindex,
        pagesize: this.pageSize,
      });
      this.$hys.clearLoading();
      this.totalCount = res.Count;
      if (this.pageindex == 1) {
        this.list = [];
      }
      if (res.Data && res.Data.length < this.pageSize) {
        this.finished = true;
      }
      if (res.IsSuccess) {
        let dataArr = [];
        if (res.Data) {
          res.Data.map((item) => {
            item.hover = false;
            if (this.list.findIndex((tag) => tag.Id == item.Id) == -1) {
              dataArr.push(item);
            }
          });
        }
        this.list = this.list.concat(dataArr);
      } else {
        this.$toast({ position: "bottom", message: res.Msg });
        this.finished = true;
      }
    },
    async lookMsg(item) {
      let link = "";
      switch (item.LinkType) {
        case 10:
          link = this.LinkTypeCode.ProductDetails; //商品详情
          break;
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
          link = this.LinkTypeCode.OrderDetails; //订单详情
          break;
        case 16:
          link = this.LinkTypeCode.MyCoupon; //我的优惠券
          break;
        case 17:
          link = this.LinkTypeCode.MyCollection; //我的收藏
          break;
        case 19:
        case 22:
          link = this.LinkTypeCode.Home; //首页
          break;
        case 20:
        case 21:
          link = this.LinkTypeCode.ActivityAreaList; //活动
          break;
        case 26:
          link = this.LinkTypeCode.MyQualifications; //我的资质
          break;
      }
      //购物车
      if (item.LinkType == 18) {
        this._goHome(3);
        return;
      }
      if (!item.IsRead) {
        const res = await this.postAction(
          "/api_customers/CustomerMessage/UpdateBatch",
          [item.Id]
        );
        if (res.IsSuccess && res.Data) {
          this._jump(link, item.LinkContent);
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
        }
      } else {
        this._jump(link, item.LinkContent);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.msg-list {
  border-radius: 2px;
  border: 1px solid rgba(232, 232, 232, 1);
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 30px;
  min-height: 668px;

  /deep/.van-tabs {
    /deep/.van-tabs__wrap {
      border-bottom: 2px solid #3183ec;
    }
  }

  /deep/.van-tab {
    justify-content: flex-start;
    width: 120px;
    flex: none;
    align-items: flex-start;
  }

  /deep/.van-col.mr20 {
    width: calc((100% - 20px) / 2);
    cursor: pointer;

    .show-detail-right {
      width: 20px;
      height: 20px;
      background: url(../../assets/mine/right-arrow-icon.png) no-repeat;
      background-size: 100%;
    }

    &:hover {
      .text-left > span {
        color: #0f6ee9;
      }

      .show-detail-right {
        background: url(../../assets/mine/right-arrow-icon-h.png) no-repeat;
        background-size: 100%;
      }
    }

    &:nth-child(even) {
      margin-right: 0;
    }
  }
}

/deep/ .van-cell__title {
  width: ~"calc(100% - 130px)";
  flex: inherit;
  webkit-box-flex: inherit;
  -webkit-flex: inherit;
}

.tagMark {
  position: relative;
  padding-left: 16px;

  &:before {
    content: "";
    width: 8px;
    height: 8px;
    background: #ff3939;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
</style>
<style lang="less">
.msg-list {
  .van-tab--active {
    color: #409eff;
  }
}
</style>
